/**
 * 有効期間開始からバージョンコード (YYYY.MM.DD) を生成する。
 * `new Date` は使わず、文字列先頭の YYYY-MM-DD のみを見る（UTC ずれ防止）。
 */
export const toStartDateVersionCode = (enabledFrom: string): string => {
  const trimmed = (enabledFrom || '').trim()
  const match = trimmed.match(/^(\d{4})-(\d{2})-(\d{2})/)
  if (!match) {
    throw new Error(
      `有効期間 開始からバージョンコードを生成できません: ${enabledFrom || '(空)'}`,
    )
  }
  const month = Number(match[2])
  const day = Number(match[3])
  if (month < 1 || month > 12) {
    throw new Error(`有効期間 開始の月が不正です: ${enabledFrom}`)
  }
  if (day < 1 || day > 31) {
    throw new Error(`有効期間 開始の日が不正です: ${enabledFrom}`)
  }
  return `${match[1]}.${match[2]}.${match[3]}`
}
